import api from './api';

export interface ExamTopicSummary {
  topicId: string;
  examId: string;
  title: string;
  topicName: string;
  order: number;
  subtopics: string[];
}

export interface ExamTopicNote {
  noteId: string;
  userId: string;
  examId: string;
  topicId: string;
  content: string;
  createdAt: string;
  updatedAt: string;
}

interface ExamTopicsResponse {
  examId: string;
  examName: string;
  subject: string;
  topics: ExamTopicSummary[];
}

export const fetchExamTopicsForSidebar = async (examId: string): Promise<ExamTopicsResponse> => {
  const response = await api.get(`/exam-topics/${encodeURIComponent(examId)}/topics`);
  return response?.data?.data as ExamTopicsResponse;
};

export const fetchTopicNotes = async (examId: string, topicId: string): Promise<ExamTopicNote[]> => {
  const response = await api.get(`/exams/${encodeURIComponent(examId)}/topics/${encodeURIComponent(topicId)}/notes`);
  const notes = response?.data?.data;
  return Array.isArray(notes) ? notes : [];
};

export const createTopicNote = async (
  examId: string,
  topicId: string,
  content: string
): Promise<ExamTopicNote> => {
  const response = await api.post(`/exams/${encodeURIComponent(examId)}/topics/${encodeURIComponent(topicId)}/notes`, {
    content,
  });

  return response?.data?.data as ExamTopicNote;
};

export const updateTopicNote = async (noteId: string, content: string): Promise<ExamTopicNote> => {
  const response = await api.put(`/notes/${encodeURIComponent(noteId)}`, { content });
  return response?.data?.data as ExamTopicNote;
};

export const deleteTopicNote = async (noteId: string): Promise<void> => {
  await api.delete(`/notes/${encodeURIComponent(noteId)}`);
};

export const fetchExamNoteCounts = async (examId: string): Promise<Record<string, number>> => {
  const response = await api.get(`/exams/${encodeURIComponent(examId)}/notes/counts`);
  const rows = response?.data?.data;
  if (!Array.isArray(rows)) {
    return {};
  }

  return rows.reduce((acc: Record<string, number>, row: { topicId: string; count: number }) => {
    if (typeof row?.topicId === 'string' && row.topicId.trim()) {
      acc[row.topicId] = Number(row.count || 0);
    }
    return acc;
  }, {});
};
